const headers = {
  consolidated: {
    regular: claim => [{
      text: 'Business Unit',
      cellType: 'BusinessUnitDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.business_unit?.name || '',
      valueFn: r => r.data.object.business_unit?.name || ''
    }, {
      text: 'Project Name',
      cellType: 'ProjectSelector',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report?.project_name || '',
      valueFn: r => r.data.object.claim_project_report?.project_name || ''
    }, {
      text: 'Project Type',
      cellType: 'ProjectTypeDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report?.program_type || '',
      valueFn: r => r.data.object.claim_project_report?.program_type || ''
    }, {
      text: 'SME/RDEC',
      fieldName: 'rate_type',
      cellType: 'text',
      disabled: true,
      translateValue: true,
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.rate_type || '',
      valueFn: r => r.data.object.rate_type || ''
    }, {
      text: 'Methodology Item',
      fieldName: 'rate_type',
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report.cost_methodology_type || '',
      disabled: true,
      valueFn: r => r.data.object.claim_project_report.cost_methodology_type || '',
      translateValue: true
    }, {
      text: 'Name',
      fieldName: 'name',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.name,
      valueFn: r => r.data.object.fragmentable?.name || ''
    }, {
      text: 'Total Cost (£)',
      fieldName: 'total',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.total),
      valueFn: r => r.data.object.total ?? ''
    }, {
      text: 'Capitalised Costs (if any)',
      fieldName: 'capitalised_costs',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.capitalised_costs),
      valueFn: r => r.data.object.capitalised_costs ?? ''
    }, {
      text: 'Direct R&D%',
      fieldName: 'direct_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.direct_rnd_percentage),
      valueFn: r => r.data.object.direct_rnd_percentage != null ? `${Number(r.data.object.direct_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Indirect R&D%',
      fieldName: 'indirect_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.indirect_rnd_percentage),
      valueFn: r => r.data.object.indirect_rnd_percentage != null ? `${Number(r.data.object.indirect_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Consolidated % of Time Spent',
      fieldName: 'consolidated_percentage_of_time_spent',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.consolidated_percentage_of_time_spent),
      valueFn: r => r.data.object.consolidated_percentage_of_time_spent != null ? `${Number(r.data.object.consolidated_percentage_of_time_spent).toFixed(1)}%` : ''
    }, {
      text: 'Eligible R&D %',
      fieldName: 'eligible_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_rnd_percentage),
      valueFn: r => r.data.object.eligible_rnd_percentage != null ? `${Number(r.data.object.eligible_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'R&D Amount',
      fieldName: 'rnd_amount',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.rnd_amount),
      valueFn: r => r.data.object.rnd_amount ?? ''
    }, {
      text: 'P&L R&D Expenditure',
      fieldName: 'pnl_expenditure',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.pnl_expenditure),
      valueFn: r => r.data.object.pnl_expenditure ?? ''
    }, {
      text: 's1308 Claim',
      fieldName: 's1308_claim',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.s1308_claim),
      valueFn: r => r.data.object.s1308_claim ?? ''
    }].filter(Boolean),
    realtime: claim => [{
      text: 'Business Unit',
      cellType: 'BusinessUnitDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.business_unit?.name || '',
      valueFn: r => r.data.object.business_unit?.name || ''
    }, {
      text: 'Project Name',
      cellType: 'ProjectSelector',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report?.project_name || '',
      valueFn: r => r.data.object.claim_project_report?.project_name || ''
    }, {
      text: 'Project Type',
      cellType: 'ProjectTypeDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report?.program_type || '',
      valueFn: r => r.data.object.claim_project_report?.program_type || ''
    }, {
      text: 'SME/RDEC',
      fieldName: 'rate_type',
      cellType: 'text',
      disabled: true,
      translateValue: true,
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.rate_type || '',
      valueFn: r => r.data.object.rate_type || ''
    }, {
      text: 'Methodology Item',
      fieldName: 'rate_type',
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report.cost_methodology_type || '',
      disabled: true,
      valueFn: r => r.data.object.claim_project_report.cost_methodology_type || '',
      translateValue: true
    }, {
      text: 'Name',
      fieldName: 'name',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.name,
      valueFn: r => r.data.object.fragmentable?.name || ''
    }, {
      text: 'Total Cost (£)',
      fieldName: 'total',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.total),
      valueFn: r => r.data.object.total ?? ''
    }, {
      text: 'Capitalised Costs (if any)',
      fieldName: 'capitalised_costs',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.capitalised_costs),
      valueFn: r => r.data.object.capitalised_costs ?? ''
    }, {
      text: 'Direct R&D%',
      fieldName: 'direct_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.direct_rnd_percentage),
      valueFn: r => r.data.object.direct_rnd_percentage != null ? `${Number(r.data.object.direct_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Indirect R&D%',
      fieldName: 'indirect_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.indirect_rnd_percentage),
      valueFn: r => r.data.object.indirect_rnd_percentage != null ? `${Number(r.data.object.indirect_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Consolidated % of Time Spent',
      fieldName: 'consolidated_percentage_of_time_spent',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.consolidated_percentage_of_time_spent),
      valueFn: r => r.data.object.consolidated_percentage_of_time_spent != null ? `${Number(r.data.object.consolidated_percentage_of_time_spent).toFixed(1)}%` : ''
    }, {
      text: 'Eligible R&D %',
      fieldName: 'eligible_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_rnd_percentage),
      valueFn: r => r.data.object.eligible_rnd_percentage != null ? `${Number(r.data.object.eligible_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'R&D Amount',
      fieldName: 'rnd_amount',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.rnd_amount),
      valueFn: r => r.data.object.rnd_amount ?? ''
    }, {
      text: 'P&L R&D Expenditure',
      fieldName: 'pnl_expenditure',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.pnl_expenditure),
      valueFn: r => r.data.object.pnl_expenditure ?? ''
    }, {
      text: 's1308 Claim',
      fieldName: 's1308_claim',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.s1308_claim),
      valueFn: r => r.data.object.s1308_claim ?? ''
    }].filter(Boolean)
  }
};
const buildRows = {
  consolidated: {
    regular: (costFragments, buildCustomCell) => costFragments.map(costFragment => ({
      key: costFragment.id,
      data: {
        object: costFragment
      },
      columns: [buildCustomCell({
        cellType: 'BusinessUnitDropdown',
        costFragment
      }), buildCustomCell({
        cellType: 'ProjectSelector',
        costFragment
      }), buildCustomCell({
        cellType: 'ProjectTypeDropdown',
        costFragment
      }), buildCustomCell({
        fieldName: 'rate_type',
        costFragment,
        cellType: 'text',
        disabled: true,
        translateValue: true
      }), buildCustomCell({
        fieldName: 'name',
        costFragment,
        cellType: 'text',
        model: 'fragmentable'
      }), buildCustomCell({
        fieldName: 'total',
        costFragment,
        cellType: 'number'
      }), buildCustomCell({
        fieldName: 'capitalised_costs',
        costFragment,
        cellType: 'number'
      }), buildCustomCell({
        fieldName: 'direct_rnd_percentage',
        costFragment,
        cellType: 'percentage'
      }), buildCustomCell({
        fieldName: 'indirect_rnd_percentage',
        costFragment,
        cellType: 'percentage'
      }), buildCustomCell({
        fieldName: 'consolidated_percentage_of_time_spent',
        costFragment,
        cellType: 'percentage'
      }), buildCustomCell({
        fieldName: 'eligible_rnd_percentage',
        costFragment,
        cellType: 'percentage',
        disabled: true
      }), buildCustomCell({
        fieldName: 'rnd_amount',
        costFragment,
        cellType: 'number',
        disabled: true
      }), buildCustomCell({
        fieldName: 'pnl_expenditure',
        costFragment,
        cellType: 'number',
        disabled: true
      }), buildCustomCell({
        fieldName: 's1308_claim',
        costFragment,
        cellType: 'number',
        disabled: true
      })]
    })),
    realtime: (costFragments, buildCustomCell) => costFragments.map(costFragment => ({
      key: costFragment.id,
      data: {
        object: costFragment
      },
      columns: [buildCustomCell({
        cellType: 'BusinessUnitDropdown',
        costFragment
      }), buildCustomCell({
        cellType: 'ProjectSelector',
        costFragment
      }), buildCustomCell({
        cellType: 'ProjectTypeDropdown',
        costFragment
      }), buildCustomCell({
        fieldName: 'rate_type',
        costFragment,
        cellType: 'text',
        disabled: true,
        translateValue: true
      }), buildCustomCell({
        fieldName: 'name',
        costFragment,
        cellType: 'text',
        model: 'fragmentable'
      }), buildCustomCell({
        fieldName: 'total',
        costFragment,
        cellType: 'number'
      }), buildCustomCell({
        fieldName: 'capitalised_costs',
        costFragment,
        cellType: 'number'
      }), buildCustomCell({
        fieldName: 'direct_rnd_percentage',
        costFragment,
        cellType: 'percentage'
      }), buildCustomCell({
        fieldName: 'indirect_rnd_percentage',
        costFragment,
        cellType: 'percentage'
      }), buildCustomCell({
        fieldName: 'consolidated_percentage_of_time_spent',
        costFragment,
        cellType: 'percentage'
      }), buildCustomCell({
        fieldName: 'eligible_rnd_percentage',
        costFragment,
        cellType: 'percentage',
        disabled: true
      }), buildCustomCell({
        fieldName: 'rnd_amount',
        costFragment,
        cellType: 'number',
        disabled: true
      }), buildCustomCell({
        fieldName: 'pnl_expenditure',
        costFragment,
        cellType: 'number',
        disabled: true
      }), buildCustomCell({
        fieldName: 's1308_claim',
        costFragment,
        cellType: 'number',
        disabled: true
      })]
    }))
  }
};
export const staffingCostFragmentTableSettings = {
  headers,
  buildRows
};